(() => {
  const toggle = document.querySelector("[data-menu-toggle]");
  const nav = document.getElementById("MobileNav");
  if (toggle && nav) {
    toggle.addEventListener("click", () => {
      const open = nav.hasAttribute("hidden") === false;
      if (open) nav.setAttribute("hidden", "");
      else nav.removeAttribute("hidden");
      toggle.setAttribute("aria-expanded", String(!open));
    });
  }
})();
